module.exports = __webpack_public_path__ + "assets/img/noVideo.a4f025a0.svg";